// Модуль для отправки целей в Яндекс.Метрику по data-ym-goal

/**
 * Отправляет цель в Яндекс.Метрику
 * @param goalName Имя цели
 * @param params Дополнительные параметры цели
 */
export function sendYmGoal(goalName: string, params?: Record<string, any>): void {
  try {
    const ym = (window as any).ym as undefined | ((...args: any[]) => void);
    if (typeof ym === 'function') {
      // Замените 12345678 на ваш реальный ID счетчика
      if (params) {
        ym(97951132, 'reachGoal', goalName, params);
      } else {
        ym(97951132, 'reachGoal', goalName);
      }
      // Логирование успешной отправки
      if (window.console && window.console.log) {
       // window.console.log(`Метрика: отправлена цель "${goalName}"`, params || '');
      }
    } else {
      // Можно добавить логирование для отладки
      if (window.console && window.console.warn) {
        window.console.warn('Метрика не инициализирована или не найдена: цель', goalName);
      }
    }
  } catch (error) {
    // Обработка ошибок
    if (window.console && window.console.error) {
      window.console.error('Ошибка отправки цели в Метрику:', error);
    }
  }
}

/**
 * Программно отправляет цель для элемента с data-ym-goal и data-ym-params
 * @param element HTML элемент с атрибутами data-ym-goal и data-ym-params
 */
export function sendElementYmGoal(element: HTMLElement): void {
  const goal = element.getAttribute('data-ym-goal');
  if (!goal) return;

  // Получаем параметры цели из data-ym-params
  const goalParamsAttr = element.getAttribute('data-ym-params');
  let params: Record<string, any> | undefined;
  
  if (goalParamsAttr) {
    try {
      params = JSON.parse(goalParamsAttr);
    } catch (error) {
      if (window.console && window.console.warn) {
        window.console.warn('Ошибка парсинга параметров цели:', goalParamsAttr, error);
      }
    }
  }
  
  sendYmGoal(goal, params);
  element.setAttribute('data-ym-goal-sent', '1');
}

/**
 * Делегированный обработчик кликов по элементам с data-ym-goal
 * Отправляет цель только один раз за сессию для каждого элемента
 * Для ссылок задерживает переход, чтобы цель успела отправиться
 */
document.addEventListener('click', (event: MouseEvent) => {
  let target = event.target as HTMLElement | null;
  while (target && target !== document.body) {
    if (target.hasAttribute('data-ym-goal')) {
      // Проверяем, отправляли ли уже цель с этого элемента
      if (target.hasAttribute('data-ym-goal-sent')) {
        break;
      }
      
      const goal = target.getAttribute('data-ym-goal');
      if (goal) {
        // Получаем параметры цели из data-ym-params
        const goalParamsAttr = target.getAttribute('data-ym-params');
        let params: Record<string, any> | undefined;
        
        if (goalParamsAttr) {
          try {
            params = JSON.parse(goalParamsAttr);
          } catch (error) {
            if (window.console && window.console.warn) {
              window.console.warn('Ошибка парсинга параметров цели:', goalParamsAttr, error);
            }
          }
        }
        
        // Если это ссылка, задерживаем переход
        if (target.tagName.toLowerCase() === 'a') {
          const link = target as HTMLAnchorElement;
          const href = link.href;
          
          // Предотвращаем стандартное поведение
          event.preventDefault();
          
          // Отправляем цель
          sendYmGoal(goal, params);
          target.setAttribute('data-ym-goal-sent', '1');
          
          // Задерживаем переход на 300ms для отправки цели
          setTimeout(() => {
            // Проверяем, нужно ли открыть в новой вкладке
            if (link.target === '_blank' || event.ctrlKey || event.metaKey) {
              window.open(href, '_blank');
            } else {
              window.location.href = href;
            }
          }, 300);
        } else {
          // Для обычных элементов отправляем как раньше
          sendYmGoal(goal, params);
          target.setAttribute('data-ym-goal-sent', '1');
        }
      }
      break;
    }
    target = target.parentElement;
  }
});
